export default "__VITE_ASSET__f1b2d5de__"